import PropTypes from "prop-types";
import React from "react";

import { connect } from "react-redux";

import { Link, useLocation, useNavigate } from "react-router-dom";

// Custom Components
import CustomButton from "../AuthenticationComponents/CustomButton";
import NotificationDropdown from "../Common/NotificationDropdown";
import arrowRightIcon from "../../assets/images/authentication/arrow-right.svg";
import homeOutline from "../../assets/images/sidebar/home-outline.svg";
import homeOrange from "../../assets/images/sidebar/home-orange.svg";
import walletOutline from "../../assets/images/sidebar/wallet-outline.svg";
import walletOrange from "../../assets/images/sidebar/wallet-orange.svg";
import profile from "../../assets/images/user-dashboard/profile.svg";
import profileOrange from "../../assets/images/user-dashboard/profile-orange.svg";
import logoDashboard from "../../assets/images/user-dashboard/logo-dashboard.svg";

//Import API
import endpoints from "../../api/endpoints";
import { get, patch } from "../../api/axios";

//i18n
import { withTranslation } from "react-i18next";

// Redux Store
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions";

const Header = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [notifications, setNotifications] = React.useState([]);
  const [unreadCount, setUnreadCount] = React.useState(0);

  const isActiveRoute = (path) => {
    return (
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
  };

  const handleReferFriend = () => {
    navigate("/referrals");
  };

  // Fetch notifications
  const fetchNotifications = React.useCallback(async () => {
    try {
      const response = await get(
        `${endpoints.notificationsUnread}&page=1&page_size=5`,
      );
      if (response.data.success) {
        const notificationsData = response.data.data.data || [];
        const transformedNotifications = notificationsData.map((notif) => ({
          id: notif.id,
          title: notif.notification_type?.replace(/_/g, " ") || "Notification",
          message: notif.data?.message || notif.message || "",
          type: notif.notification_type || "system",
          read: notif.is_read || false,
          timeAgo: formatTimeAgo(notif.created_at),
          url: notif.data?.url || notif.data?.redirect_url || null,
        }));
        setNotifications(transformedNotifications);
      }
    } catch (err) {
      console.error("Failed to fetch notifications:", err);
    }
  }, []);

  // Fetch unread count separately
  const fetchUnreadCount = React.useCallback(async () => {
    try {
      const response = await get(endpoints.unreadCount);
      if (response.data.success) {
        const count = response.data.data?.unread_count || 0;
        setUnreadCount(Number(count));
      }
    } catch (err) {
      console.error("Failed to fetch unread count:", err);
    }
  }, []);

  // Format time ago
  const formatTimeAgo = (dateString) => {
    if (!dateString) return "Unknown";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Fetch notifications on mount and set up polling
  React.useEffect(() => {
    fetchNotifications();
    fetchUnreadCount();

    // Poll for new notifications every 10 seconds
    const interval = setInterval(() => {
      fetchNotifications();
      fetchUnreadCount();
    }, 10000);

    return () => clearInterval(interval);
  }, [fetchNotifications, fetchUnreadCount]);

  const handleMarkAsRead = async (notificationId) => {
    try {
      if (notificationId === "all") {
        // Mark all as read using the read-all endpoint
        await patch(endpoints.markAllNotificationsRead);
        setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
        fetchUnreadCount();
      } else {
        const endpoint = endpoints.markNotificationRead.replace(
          "{{NOTIFICATION_ID}}",
          notificationId,
        );
        await patch(endpoint);
        setNotifications((prev) =>
          prev.map((n) => (n.id === notificationId ? { ...n, read: true } : n)),
        );
        fetchUnreadCount();
      }
    } catch (err) {
      console.error("Failed to mark notification as read:", err);
    }
  };
  return (
    <React.Fragment>
      {props.leftMenu && (
        <div
          className="sidebar-overlay"
          onClick={() => props.toggleLeftmenu(false)}
          aria-label="Close sidebar"
        />
      )}
      <header id="page-topbar">
        <div className="navbar-header">
          {/* Original header structure - commented out */}
          {/* <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoSm} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="" height="20" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSm} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="" height="20" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn"
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

            <Form className="app-search d-none d-lg-block">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder={props.t("Search") + "..."}
                />
                <span className="uil-search"></span>
              </div>
            </Form>
          </div>

          <div className="d-flex">

            <Dropdown
              className="d-inline-block d-lg-none ms-2"
              onClick={() => {
                setsearch(!search);
              }}
              type="button"
            >
              <DropdownToggle
                className="btn header-item noti-icon waves-effect"
                id="page-header-search-dropdown"
                tag="button"
              > <i className="uil-search" />
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                <Form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <Input type="text" className="form-control" placeholder="Search ..." aria-label="Recipient's username" />
                      <div className="input-group-append">
                        <Button className="btn btn-primary" type="submit"><i className="mdi mdi-magnify"></i></Button>
                      </div>
                    </div>
                  </div>
                </Form>
              </DropdownMenu>
            </Dropdown>

            <LanguageDropdown />

            <Dropdown
              className="d-none d-lg-inline-block ms-1"
              isOpen={socialDrp}
              toggle={() => {
                setsocialDrp(!socialDrp);
              }}
            >
              <DropdownToggle
                className="btn header-item noti-icon waves-effect"
                tag="button"
              >
                <i className="uil-apps"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-lg dropdown-menu-end" end>
                <div className="px-lg-2">
                  <Row className="g-0">
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={github} alt="Github" />
                        <span>GitHub</span>
                      </Link>
                    </Col>
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={bitbucket} alt="bitbucket" />
                        <span>Bitbucket</span>
                      </Link>
                    </Col>
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={dribbble} alt="dribbble" />
                        <span>Dribbble</span>
                      </Link>
                    </Col>
                  </Row>

                  <Row className="g-0">
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={dropbox} alt="dropbox" />
                        <span>Dropbox</span>
                      </Link>
                    </Col>
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={mail_chimp} alt="mail_chimp" />
                        <span>Mail Chimp</span>
                      </Link>
                    </Col>
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={slack} alt="slack" />
                        <span>Slack</span>
                      </Link>
                    </Col>
                  </Row>
                </div>
              </DropdownMenu>
            </Dropdown>

            <Dropdown className="d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon waves-effect"
                data-toggle="fullscreen"
              >
                <i className="uil-minus-path"></i>
              </button>
            </Dropdown>

            <NotificationDropdown
            notifications={notifications}
            unreadCount={unreadCount}
            onMarkAsRead={handleMarkAsRead}
            onOpen={fetchNotifications}
          />

            <ProfileMenu />

            <div onClick={() => {
              props.showRightSidebarAction(!props.showRightSidebar);
            }}
              className="dropdown d-inline-block">
              <button type="button" className="btn header-item noti-icon right-bar-toggle waves-effect">
                <i className="uil-cog"></i>
              </button>
            </div>

          </div> */}

          {/* New header structure as per design */}
          <div className="new-header-container">
            {/* Left side - Hamburger button and Logo */}
            <div className="header-left">
              <button
                type="button"
                onClick={() => props.toggleLeftmenu(!props.leftMenu)}
                className="hamburger-menu-btn"
                aria-label="Toggle sidebar"
              >
                <i className="fa fa-bars" />
              </button>
              <Link to="/dashboard" className="brand-logo">
                <img
                  src={logoDashboard}
                  alt="OMAHA Food Lovers"
                  className="brand-logo-image"
                />
              </Link>
            </div>

            {/* Middle - Navigation Tabs */}
            <div className="header-center">
              <nav className="nav-tabs">
                <Link
                  to="/dashboard"
                  className={`nav-tab ${isActiveRoute("/dashboard") ? "active" : ""}`}
                >
                  <img
                    src={isActiveRoute("/dashboard") ? homeOrange : homeOutline}
                    alt="Home"
                    className="nav-tab-icon"
                  />
                  <span>Home</span>
                </Link>
                <Link
                  to="/wallet"
                  className={`nav-tab ${isActiveRoute("/wallet") ? "active" : ""}`}
                >
                  <img
                    src={
                      isActiveRoute("/wallet") ? walletOrange : walletOutline
                    }
                    alt="Wallet"
                    className="nav-tab-icon"
                  />
                  <span>Wallet</span>
                </Link>
                <Link
                  to="/profile"
                  className={`nav-tab ${isActiveRoute("/profile") ? "active" : ""}`}
                >
                  <img
                    src={isActiveRoute("/profile") ? profileOrange : profile}
                    alt="Profile"
                    className="nav-tab-icon"
                  />
                  <span>Profile</span>
                </Link>
                <div className="nav-tab notification-tab desktop-only">
                  <NotificationDropdown
                    notifications={notifications}
                    unreadCount={unreadCount}
                    onMarkAsRead={handleMarkAsRead}
                  />
                </div>
              </nav>
            </div>

            {/* Right side - Refer a Friend button (desktop) */}
            <div className="header-right">
              <CustomButton
                variant="primary"
                iconPosition="right"
                icon={arrowRightIcon}
                loading={false}
                className="desktop-refer-btn"
                onClick={handleReferFriend}
              >
                Refer a friend
              </CustomButton>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  // changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  // changeSidebarType,
})(withTranslation()(Header));
